import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './WpPreview.module.less';
import { imgLocalUrl } from '../utils/utils';
import WallpaperOpt from '../components/WallpaperOpt/WallpaperOpt';
import { logging } from '../actions/log';
import { PCStoreJsBridge } from '../nativeapi';
import { updatePreviewInfo } from '../actions/wallpaper';

const selectWpPreview = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpPreviewInfo,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const wpPreview = useSelector(selectWpPreview);

  /**
   * 注册退出按钮
   */
  useEffect(() => {
    document.onkeydown = function(event) {
      const ev = event || window.event || arguments.callee.caller.arguments[0];
      if (ev.key === 'Escape') {
        PCStoreJsBridge.wpExitMaximizeStroe().then(ret => {
          if (ret.succ) {
            dispatch(updatePreviewInfo(null));
          }
        });
      }
    };
  }, []);

  useEffect(() => {
    if (wpPreview.wallpaper && wpPreview.wallpaper.wallpaperId) {
      // 更新页面 PV
      dispatch(
        logging({
          category: 'Wallpaper',
          action: 'P_Wallpaper_Preview',
          label: '',
          param2: {
            source: `Wallpaper_Preview`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            wallpaperId: wpPreview.wallpaper.wallpaperId,
          },
        }),
      );
    }
  }, [wpPreview]);

  return (
    <div>
      <div className={styles.wpPreview}>
        {wpPreview && wpPreview.isShow && wpPreview.wallpaper && wpPreview.wallpaper.wallpaperId && (
          <div className={styles.wpPreview_box}>
            <img className={styles.wpPreview_img} src={imgLocalUrl(wpPreview.url)} />
            <div className={styles.wpPreview_opt}>
              <WallpaperOpt
                wallpaper={{ ...wpPreview.wallpaper }}
                cardInfo={{
                  isBig: true,
                  isCollect: true,
                  isWallpaper: true,
                  isDeleteColl: false,
                  isDeleteUsed: false,
                  isPreview: false,
                  isPreviewOut: true,
                }}
                logInfo={{ source: 'Wallpaper_Preview' }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
